<div
  class="fixed mx-auto h-full w-full md:bottom-0 md:left-0 md:flex md:flex-col md:items-center md:justify-center mdMax:bottom-0 mdMax:left-0 mdMax:right-0 mdMax:top-0"
  [style.z-index]="'130 !important'"
>
  <app-modal-filler-atom
    class="hidden md:block"
    (click)="close($event)"
    [withBackdrop]="true"
    [index]="index()"
  ></app-modal-filler-atom>
  <div
    class="fixed mx-auto h-full w-full md:bottom-0 md:left-0 md:flex md:flex-col md:items-center md:justify-center mdMax:bottom-0 mdMax:left-0 mdMax:right-0 mdMax:top-0"
    [style.z-index]="index() + 100 + ' !important'"
  >
    <app-modal-filler-atom
      class="hidden md:block"
      [withBackdrop]="false"
      (click)="close($event)"
      [index]="index()"
    ></app-modal-filler-atom>
    <div
      class="flex h-screen flex-col overflow-y-auto pb-36 scrollbar-hide md:relative md:my-20 md:h-auto md:max-h-screen md:w-full md:max-w-screen-sm md:rounded-3xl md:pb-0 kiosk:md:max-h-[90vh] kiosk:md:max-w-[90vw]"
      [style.z-index]="index() + 50 + ' !important'"
      [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
      [style.color]="textColor() | contentBuilderColor"
      style="max-height: 1021px !important"
    >
      @if (product().id) {
        <header
          class="relative flex w-full justify-center md:rounded-t-3xl small-desktop-height:hidden"
          [class.py-8]="!product().images"
          [class.bg-primary-300]="product().images"
        >
          @if (product().images?.cover?.url) {
            <img
              [src]="product().images?.cover?.url"
              class="panel-image h-64 max-h-64 min-h-64 object-cover md:h-96 md:max-h-96 md:min-h-96 md:rounded-t-3xl"
              loading="lazy"
            />
          }
          <app-rounded-icon-button
            class="absolute right-5 top-5"
            [class.top-8]="isNotched()"
            [icon]="'icon-cross'"
            [size]="'sm'"
            [type]="'normal'"
            [overrideBackgroundColor]="buttonBackgroundColor()"
            [overrideColor]="buttonTextColor()"
            (click)="close($event)"
          ></app-rounded-icon-button>
        </header>

        <header
          class="relative flex hidden w-full md:rounded-t-3xl small-desktop-height:flex"
          [class.py-8]="!product().images"
        >
          @if (product().images?.cover?.url) {
            <img
              [src]="product().images?.cover?.url"
              class="m-4 h-40 w-40 rounded-2xl object-cover"
              loading="lazy"
            />
          }
          <app-rounded-icon-button
            class="absolute right-5 top-5"
            [class.top-8]="isNotched()"
            [icon]="'icon-cross'"
            [size]="'sm'"
            [type]="'normal'"
            [overrideBackgroundColor]="buttonBackgroundColor()"
            [overrideColor]="buttonTextColor()"
            (click)="close($event)"
          ></app-rounded-icon-button>
          <h1
            class="m-4 mr-20 flex items-center break-words font-accent text-2xl font-bold leading-8xs"
            [style.color]="textColor() ?? headingColor() | contentBuilderColor"
          >
            {{ product()[productKeys.Name] }}
          </h1>
        </header>

        <div class="flex flex-col px-5 py-4 text-neutral-800 lg:pb-4">
          <h1
            class="mb-3 break-words font-accent text-2xl font-bold leading-8xs small-desktop-height:hidden"
            [style.color]="textColor() ?? headingColor() | contentBuilderColor"
          >
            {{ product()[productKeys.Name] }}
          </h1>
          @if (product()[productKeys.Description]) {
            <p
              class="mb-3 whitespace-pre-line font-base text-base leading-snug"
              [style.color]="textColor() ?? descriptionColor() | contentBuilderColor"
            >
              {{ product()[productKeys.Description] }}
            </p>
          }
          @if (canDisplayProductPanel()) {
            @if (displayPrice()) {
              <div class="mb-3 font-accent text-sm font-bold">
                @if (product()[productKeys.PriceToDisplay]) {
                  <p
                    class="notranslate mb-1 font-base text-base font-normal"
                    [style.color]="textColor() ?? inactiveStateColor() | contentBuilderColor"
                  >
                    {{ product()[productKeys.PriceToDisplay] }}
                  </p>
                }
              </div>
            }
            <ul class="flex flex-wrap pb-3">
              @for (label of visibleLabels(product()[productKeys.Labels]); track label.name) {
                <li class="py-1 pl-0 pr-3">
                  <app-tag-atom
                    [text]="label.name"
                    [lineThrough]="label.line_through"
                    [bold]="false"
                  ></app-tag-atom>
                </li>
              }
            </ul>
            @if (allergensLine()) {
              <div
                class="mb-2"
                [style.color]="textColor() ?? descriptionColor() | contentBuilderColor"
              >
                <p class="m-0 font-base text-base leading-snug">{{ allergensLine() }}</p>
              </div>
            }
            @if (orderedAdditionGroups()?.length) {
              <div
                [style.color]="textColor() ?? descriptionColor() | contentBuilderColor"
                class="pb-60 pt-5"
              >
                @for (additionGroup of orderedAdditionGroups(); track additionGroup.id) {
                  <div class="pb-8">
                    <h2 class="font-accent text-md font-bold">
                      {{ additionGroup[additionGroupKeys.Name] }}
                    </h2>
                    @if (!hideAdditionGroupDetails()) {
                      <p
                        class="font-base text-base font-normal"
                        [class.text-secondary-700]="!isAdditionGroupMinCountReached(additionGroup)"
                        [style.color]="textColor() ?? inactiveStateColor() | contentBuilderColor"
                      >
                        {{ additionGroup | appFn: additionGroupTitle }}
                      </p>
                    }
                    <div class="flex flex-col gap-1">
                      @for (addition of additionGroup[additionGroupKeys.Items]; track addition.id) {
                        <label
                          [for]="addition[productKeys.Id]"
                          class="-mx-3 flex cursor-pointer justify-between rounded-lg border p-3 align-middle transition-colors hover:border-neutral-300 hover:bg-neutral-100"
                          [ngClass]="{
                            'opacity-40':
                              getMaxAdditionCount(additionGroup, addition) === 0 ||
                              !isAvailable(addition),
                            'cursor-not-allowed':
                              getMaxAdditionCount(additionGroup, addition) === 0 ||
                              !isAvailable(addition),
                          }"
                          [class.border-neutral-300]="addition[productKeys.IsChecked]"
                          [class.bg-neutral-100]="addition[productKeys.IsChecked]"
                          [class.border-transparent]="!addition[productKeys.IsChecked]"
                        >
                          @if (addition && addition[productKeys.Name]) {
                            <div class="flex items-center">
                              <div
                                class="flex flex-row items-center"
                                [ngClass]="{
                                  'opacity-50': !isAvailable(addition),
                                }"
                              >
                                <input
                                  [id]="addition[productKeys.Id]"
                                  name="{{ addition[productKeys.Name] }}"
                                  type="checkbox"
                                  [disabled]="
                                    getMaxAdditionCount(additionGroup, addition) === 0 ||
                                    !isAvailable(addition)
                                  "
                                  [(ngModel)]="addition[productKeys.IsChecked]"
                                  (change)="selectAddition(addition)"
                                  #checkbox
                                  class="form-checkbox mr-4 h-6 w-6 border text-primary-600"
                                />
                                <div>
                                  <p class="flex flex-wrap items-center gap-1">
                                    <span>{{ addition[productKeys.Name] }}</span>
                                    <app-catalog-filter-match-tags
                                      [product]="addition"
                                    ></app-catalog-filter-match-tags>
                                  </p>
                                  @if (addition[productKeys.Images]?.thumbnail?.url) {
                                    <div class="flex items-center space-x-4">
                                      @if (
                                        (!addition[productKeys.MaxCount] ||
                                          (addition[productKeys.MaxCount] ?? 0) > 1) &&
                                        addition[productKeys.IsChecked]
                                      ) {
                                        <div
                                          (click)="
                                            $event.preventDefault(); $event.stopPropagation()
                                          "
                                        >
                                          <app-counter-atom
                                            [size]="'S'"
                                            [min]="
                                              $any(
                                                addition[productKeys.MinCount]
                                                  ? addition[productKeys.MinCount]
                                                  : 1
                                              )
                                            "
                                            [max]="getMaxAdditionCount(additionGroup, addition)"
                                            [backgroundColor]="$any(buttonBackgroundColor())"
                                            [textColor]="$any(buttonTextColor())"
                                            [count]="
                                              $any(
                                                addition[productKeys.Quantity]
                                                  ? addition[productKeys.Quantity]
                                                  : addition[productKeys.MinCount]
                                              )
                                            "
                                            (countChange)="
                                              changeNbAddition(
                                                $event,
                                                addition[productKeys.Id],
                                                addition
                                              )
                                            "
                                          >
                                          </app-counter-atom>
                                        </div>
                                      }
                                      @if (
                                        addition &&
                                        (addition[productKeys.Price] < 0 ||
                                          addition[productKeys.Price] > 0)
                                      ) {
                                        <span
                                          class="text-right"
                                          [ngClass]="{
                                            'opacity-50': !addition[productKeys.IsChecked],
                                          }"
                                          [style.color]="priceColor() | contentBuilderColor"
                                        >
                                          <app-price-atom
                                            [amount]="addition[productKeys.Price]"
                                            [discount]="!!addition[productKeys.Discount]"
                                            [displayPlus]="true"
                                          >
                                          </app-price-atom>
                                        </span>
                                      }
                                      @if (addition[productKeys.Discount]) {
                                        <span
                                          class="ml-1 text-right"
                                          [ngClass]="{
                                            'opacity-50': !addition[productKeys.IsChecked],
                                          }"
                                        >
                                          <app-price-atom
                                            [displayPlus]="true"
                                            [amount]="addition[productKeys.Discount] ?? 0"
                                            [style.color]="priceColor() | contentBuilderColor"
                                          ></app-price-atom>
                                        </span>
                                      }
                                    </div>
                                  }
                                </div>
                                @if (!isAvailable(addition)) {
                                  <span class="ml-1.5"
                                    >- {{ 'product-add-modal.unavailable' | translate }}</span
                                  >
                                }
                              </div>
                            </div>
                          }
                          @if (!addition[productKeys.Images]?.thumbnail?.url) {
                            <div class="flex items-center space-x-4">
                              @if (
                                (!addition[productKeys.MaxCount] ||
                                  (addition[productKeys.MaxCount] ?? 0) > 1) &&
                                addition[productKeys.IsChecked]
                              ) {
                                <div (click)="$event.preventDefault(); $event.stopPropagation()">
                                  <app-counter-atom
                                    [size]="'S'"
                                    [min]="
                                      $any(
                                        addition[productKeys.MinCount]
                                          ? addition[productKeys.MinCount]
                                          : 1
                                      )
                                    "
                                    [max]="getMaxAdditionCount(additionGroup, addition)"
                                    [backgroundColor]="$any(buttonBackgroundColor())"
                                    [textColor]="$any(buttonTextColor())"
                                    [count]="
                                      $any(
                                        addition[productKeys.Quantity]
                                          ? addition[productKeys.Quantity]
                                          : addition[productKeys.MinCount]
                                      )
                                    "
                                    (countChange)="
                                      changeNbAddition($event, addition[productKeys.Id], addition)
                                    "
                                  >
                                  </app-counter-atom>
                                </div>
                              }
                              @if (
                                addition &&
                                (addition[productKeys.Price] < 0 || addition[productKeys.Price] > 0)
                              ) {
                                <span
                                  class="text-right"
                                  [ngClass]="{
                                    'opacity-50': !addition[productKeys.IsChecked],
                                  }"
                                  [style.color]="priceColor() | contentBuilderColor"
                                >
                                  <app-price-atom
                                    [amount]="addition[productKeys.Price]"
                                    [discount]="!!addition[productKeys.Discount]"
                                    [displayPlus]="true"
                                  >
                                  </app-price-atom>
                                </span>
                              }
                              @if (addition[productKeys.Discount]) {
                                <span
                                  class="ml-1 text-right"
                                  [ngClass]="{
                                    'opacity-50': !addition[productKeys.IsChecked],
                                  }"
                                >
                                  <app-price-atom
                                    [displayPlus]="true"
                                    [amount]="addition[productKeys.Discount] ?? 0"
                                    [style.color]="priceColor() | contentBuilderColor"
                                  ></app-price-atom>
                                </span>
                              }
                            </div>
                          }
                          @if (addition[productKeys.Images]?.thumbnail?.url) {
                            <div class="height-fit-content relative bg-neutral-50">
                              @if (addition[productKeys.Images]?.thumbnail?.url) {
                                <img
                                  class="push-image h-full rounded-lg object-cover"
                                  [src]="addition[productKeys.Images]?.thumbnail?.url"
                                  alt="image"
                                />
                              }
                            </div>
                          }
                        </label>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>
        @if (product()[productKeys.Type] === productTypeValues.Declinable) {
          @if (compoundItems() && compoundItems().length) {
            <div
              class="pb-60"
              #declinableOptionsElement
            >
              @for (item of compoundItems(); track item.store_id) {
                <div class="border-t border-neutral-300 px-5 last:border-b">
                  <app-compound-product-item-atom
                    [name]="item.name"
                    [description]="item.description"
                    [minCount]="item.min_count"
                    [products]="$any(item.selected)"
                    [count]="item.count"
                    [isValid]="isDeclinableCategoryValid(item)"
                    [storeId]="item.store_id"
                    [headingColor]="headingColor()"
                    [descriptionColor]="descriptionColor()"
                    [inactiveStateColor]="inactiveStateColor()"
                    [hideAdditionGroupDetails]="hideAdditionGroupDetails()"
                    (openCompound)="openCompound.emit(item.store_id)"
                  ></app-compound-product-item-atom>
                </div>
              }
            </div>
          }
        }
        @if (!product()?.id) {
          <div class="w-full flex-grow md:max-w-screen-sm">
            <div class="h-60 w-full animate-pulse bg-neutral-100"></div>
            <div class="w-full px-5 py-5">
              <p class="mb-3 h-8 w-8/12 animate-pulse rounded bg-neutral-200"></p>
              <p class="mb-3 h-5 w-11/12 animate-pulse rounded bg-neutral-50"></p>
              <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-50"></p>
            </div>
          </div>
        }
        @if (allowAddToCart()) {
          <footer
            class="absolute bottom-0 mx-auto w-full px-5 py-4 shadow-top md:sticky md:flex md:items-center md:gap-6 md:px-6"
            [class.pb-6]="isNotched()"
            [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
          >
            <div class="flex flex-col gap-3 mdMax:pb-4">
              <div
                class="flex justify-center"
                [style.color]="textColor() ?? descriptionColor() | contentBuilderColor"
              >
                <app-counter-atom
                  [type]="'light'"
                  [size]="'L'"
                  [min]="1"
                  [max]="$any(maxProduct())"
                  [backgroundColor]="$any(buttonBackgroundColor())"
                  [textColor]="$any(buttonTextColor())"
                  [count]="quantity()"
                  (countChange)="changeNbProduct($event)"
                ></app-counter-atom>
              </div>
              @if (isEdit()) {
                <div class="flex justify-center">
                  <app-button-atom
                    [label]="'basket.delete' | translate"
                    [size]="'S'"
                    [type]="'light'"
                    [overrideBgColor]="buttonBackgroundColor()"
                    [overrideTextColor]="buttonTextColor()"
                    [color]="'neutral'"
                    [icon]="'icon-garbage'"
                    [iconUrl]="orderValidationInProgress() ? 'assets/images/spinner.svg' : ''"
                    (click)="removeProduct.emit(product()[productKeys.Id])"
                  />
                </div>
              }
            </div>
            @if (
              !!shopOpensAt() === false &&
              product()[productKeys.Type] === productTypeValues.Declinable &&
              (!compoundItems() || !compoundItems().length || isButtonDisable())
            ) {
              <app-button-atom
                [type]="'primary'"
                [size]="'L'"
                [lookDisabled]="true"
                [overrideBgColor]="buttonBackgroundColor()"
                [overrideTextColor]="buttonTextColor()"
                class="md:flex-auto"
                [label]="
                  ('product-add-modal.add' | translate) +
                  ' ' +
                  quantity() +
                  ' ' +
                  ('product-add-modal.to-basket' | translate)
                "
                (clickEventEmitter)="scrollToOptions()"
              />
            }
            @if (
              !!shopOpensAt() === false &&
              product()[productKeys.Type] === productTypeValues.Declinable &&
              !(!compoundItems() || !compoundItems().length || isButtonDisable())
            ) {
              <app-button-atom
                [disabled]="!compoundItems() || !compoundItems().length || isButtonDisable()"
                [type]="'primary'"
                [size]="'L'"
                class="md:flex-auto"
                [overrideBgColor]="buttonBackgroundColor()"
                [overrideTextColor]="buttonTextColor()"
                [label]="
                  ('product-add-modal.add' | translate) +
                  ' ' +
                  quantity() +
                  ' ' +
                  ('product-add-modal.to-basket' | translate)
                "
                (clickEventEmitter)="addToCart($event)"
              >
              </app-button-atom>
            }
            @if (
              !!shopOpensAt() === false &&
              product()[productKeys.Type] !== productTypeValues.Declinable
            ) {
              <app-button-atom
                [disabled]="isButtonDisable()"
                [type]="'primary'"
                [size]="'L'"
                class="md:flex-auto"
                [overrideBgColor]="buttonBackgroundColor()"
                [overrideTextColor]="buttonTextColor()"
                [label]="
                  ('product-add-modal.add' | translate) +
                  ' ' +
                  quantity() +
                  ' ' +
                  ('product-add-modal.to-basket' | translate)
                "
                (clickEventEmitter)="addToCart($event)"
              />
            }
            @if (shopOpensAt(); as shopOpensAtValue) {
              @if (!!shopOpensAt()) {
                <app-button-atom
                  [disabled]="true"
                  [type]="'primary'"
                  [size]="'L'"
                  [overrideBgColor]="buttonBackgroundColor()"
                  [overrideTextColor]="buttonTextColor()"
                  class="md:flex-auto"
                  [label]="shopOpensAtValue"
                />
              }
            }
          </footer>
        } @else {
          <footer
            class="absolute bottom-0 mx-auto w-full px-5 py-4 shadow-top md:sticky md:flex md:items-center md:justify-center md:px-6"
            [class.pb-6]="isNotched()"
            [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
          >
            <app-button-atom
              [type]="'primary'"
              [size]="'L'"
              class="w-full md:w-auto"
              [overrideBgColor]="buttonBackgroundColor()"
              [overrideTextColor]="buttonTextColor()"
              [label]="'product-add-modal.close' | translate"
              (clickEventEmitter)="close($event)"
            />
          </footer>
        }
      }
    </div>
  </div>
</div>
